import React from "react";
import { Link } from "react-router-dom";
import { websiteLink } from "../../helpers/helpers";
import ImageControl from "../common/ImageControl";

function Logo({ logo }) {
  return (
    <>
      <div className="logo">
        <Link to={websiteLink(process.env.REACT_APP_DASHBOARD_URL)}>
          <ImageControl folder="images" src={logo} />
        </Link>
      </div>
    </>
  );
}

export default Logo;
